module.exports = __webpack_public_path__ + "static/desktop/img/production-mobile-photobook.233f953f.png";